import { useState, useEffect, useCallback } from 'react';
import { Table, Header, Container, Button, Input, CheckBox } from '../../../../../core/components';
import { ITableColumnType, ICheckboxOption } from '../../../../../core/interfaces';
import { SaveOutlined, PlusOutlined } from '@ant-design/icons';
import { ProfileService } from '../../profile/service/profile.service';
import { StepsUsersService } from '../services/steps-users.service';
import { StepsUsers as ModelUser } from '../model/steps-users.model';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { UtilService } from '../../../../../core/services/util.service';
import { Spin } from 'antd';


const columns: ITableColumnType<ModelUser>[] = [
  { title: 'First Name', dataIndex: 'firstname', key: 'firstname', filter: true },
  { title: 'Last Name', dataIndex: 'lastname', key: 'lastname', filter: true },
  { title: 'Email', dataIndex: 'email', key: 'email', filter: true },
];

const mapInvitedToModel = (r: any) =>
  new ModelUser(
    r.firstname,
    r.lastname,
    r.email,
    false,                 
    r.id || r.userId || '' 
  );

const StepsUsers = () => {
  const [invitedData, setInvitedData] = useState<ModelUser[]>([]);
  const [showForm, setShowForm] = useState(false);
  const [companyId, setCompanyId] = useState<string>('');
  const [newUser, setNewUser] = useState<ModelUser>(new ModelUser());
  const [selecteds, setSelecteds] = useState<ICheckboxOption[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const isSaveDisabled = !newUser.firstname || !newUser.lastname || !newUser.email;

  const adminOption: ICheckboxOption = {
    name: 'ckbAdmin',
    label: 'Admin',
    value: 'ckbAdmin',
    disabled: false,
  };

  useEffect(() => {
    const initializeComponent = async () => {
      try {
        const profile = await ProfileService.Get();
        if (profile && profile.companyId) {
          setCompanyId(profile.companyId);

          const invitedRaw = await StepsUsersService.GetInvitedUsers(profile.companyId);
          const invited = invitedRaw.map(mapInvitedToModel);
          setInvitedData(invited);
        } else {
          setLoading(false);
        }
      } catch (error) {
        console.error('Error initializing component:', error);
      } finally {
        setLoading(false);
      }
    };

    void initializeComponent();
  }, []);

  const addNew = useCallback(() => setShowForm(true), []);

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewUser((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const OnChangeSelected = (e: CheckboxChangeEvent, option: ICheckboxOption) => {
    setSelecteds((prevSelecteds) => {
      if (e.target.checked) {
        return [...prevSelecteds, option];
      } else {
        return prevSelecteds.filter((item) => item.value !== option.value);
      }
    });
    setNewUser((prev) => ({ ...prev, admin: e.target.checked }));
  };

  const sendInvite = async () => {
    if (!companyId || !newUser.firstname || !newUser.lastname || !newUser.email) {
      console.error('Missing required fields.');
      return;
    }

    try {
      await StepsUsersService.Post(companyId, newUser);

      const refreshedInvitedRaw = await StepsUsersService.GetInvitedUsers(companyId);
      const refreshedInvited = refreshedInvitedRaw.map(mapInvitedToModel);
      setInvitedData(refreshedInvited);

      setShowForm(false);
      setNewUser(new ModelUser());
      setSelecteds([]);
      UtilService.Alert('Success!', 'success', 'Invitation sent successfully!');
    } catch (error: unknown) {
      console.error('Error:', error instanceof Error ? error.message : 'Unknown error occurred');
    }
  };

  return (
    <Container>
      {/* <Header title='Users' buttons={[]}/> */}
      {loading ? (
        <div className='flex justify-center items-center p-4'>
          <Spin size='large' />
        </div>
      ) : (
        <>
          {/* <Table<ModelUser>
            columns={columns}
            dataSource={data}
            rowKey={(record) => record?.id || record?.email || Math.random().toString()}
            pagination={false}
          /> */}
        
          <div className='mt-2'>
            <Header title='Invited Users' 
            buttons={
              !showForm
                ? [
                    {
                      icon: { value: <PlusOutlined />, size: 'text-lg' },
                      text: { value: 'Add New', weight: 400, size: 'text-md' },
                      color: 'blue',
                      tone: 500,
                      onClick: addNew,
                    },
                  ]
                : [] 
           } />
            <Table<ModelUser>
              columns={columns}
              dataSource={invitedData}
              rowKey={(record) => record?.id || record?.email || Math.random().toString()}
              pagination={false}
            />
          </div>
        </>
      )}

      {showForm && (
        <div className='mt-4 p-4 border rounded bg-gray-100 space-y-6'>
          <div className='grid grid-cols-1 lg:grid-cols-2 mb-5 gap-x-5 gap-y-5'>
            <Input
              title='Firstname'
              type='text'
              id='firstname'
              name='firstname'
              placeholder='Enter the user firstname'
              value={newUser.firstname}
              OnChange={onChangeInput}
              validation={{ Validator: () => newUser.firstname === '' }}
              autoFocus
            />
            <Input
              title='Lastname'
              type='text'
              id='lastname'
              name='lastname'
              placeholder='Enter the user lastname'
              value={newUser.lastname}
              OnChange={onChangeInput}
              validation={{ Validator: () => newUser.lastname === '' }}
            />
            <Input
              title='Email'
              type='email'
              id='email'
              name='email'
              placeholder='Enter the user email'
              value={newUser.email}
              OnChange={onChangeInput}
              validation={{ Validator: () => newUser.email === '' }}
            />
            <div className='flex items-end justify-start'>
              <CheckBox
                title=''
                options={[adminOption]}
                selected={selecteds}
                onChange={OnChangeSelected}
                layout='horizontal'
              />
            </div>
          </div>
          <div className='flex justify-end mt-4'>
         <Button
          icon={{ value: <SaveOutlined />, size: 'text-lg' }}
          text={{ value: 'Send Invite', weight: 400, size: 'text-md' }}
          color='blue'
          tone={500}
          disabled={isSaveDisabled}
          onClick={sendInvite}
          />
      </div>
         
        </div>
      )}

     
    </Container>
  );
};

export default StepsUsers;